import React, {useEffect, useState} from 'react';
import {Button, Grid, Header, Icon, Input, Label, Message, Pagination, Segment, Table} from 'semantic-ui-react';
import GetUsers from 'services/backoffice/users/get-users';
import ActiveUser from "services/backoffice/users/active-user";
import DeactiveUser from "services/backoffice/users/deactive-user";
import DeleteUser from "services/backoffice/users/delete-users";
import {useNavigate} from "react-router-dom";
import moment from "moment/moment";
import {UserFilter} from "../../../filters/user-filter";
import {toast} from "react-toastify";
import {SessionUser} from "../../../models/session-user";
import SessionStorage from "../../../store/session";
import {useBlockUI} from "../../../shared/services/block-ui-service";
import TooltipInfo from "../../../components/tooltip/tooltip";
import {ToasterConfig} from "../../../config/ToasterConfig";
import {resetBackofficeUserPassword} from "../../../services/backoffice/users/backoffice-user-password";

const BackofficeUsersList = () => {
    const [users, setUsers] = useState<any[]>([]);
    const [error, setError] = useState<string>();
    const [loading, setLoading] = useState<boolean>(false);
    const navigate = useNavigate();
    const [filter, setFilter] = useState<UserFilter>()
    const [totalPages, setTotalPages] = useState()
    const [sessionUser, setSessionUser] = useState<SessionUser>();

    const blockUI = useBlockUI();
    useEffect(() => {
        blockUI?.setActive(loading)
    }, [loading]);

    useEffect(() => {
        async function updateSessionUser() {
            const user = await SessionStorage.getSession();
            setSessionUser(user)
        }

        updateSessionUser()
    }, [])
    const [showFilters, setShowFilters] = useState(false);

    const toggleFilters = () => {
        setShowFilters(!showFilters);
    };
    useEffect(() => {
        listUsers();
    }, [filter?.Page]);

    async function listUsers() {
        setLoading(true)
        const response = (await GetUsers(filter).finally(()=>setLoading(false)))?.data?.data;
        setTotalPages(response.totalPages);
        setUsers(response.itens);
    }

    async function toggleActivationUser(user: any) {
        try {
            const result = window.confirm(`Tem certeza que deseja ${user.isActive ? 'desativar' : 'ativar'} o usuário ${user.firstName} ${user.lastName}?`);
            if (!result) return
            setLoading(true);
            if (user) {
                const activationResult = !user.isActive ? await ActiveUser(user.id) : await DeactiveUser(user.id);
                if (activationResult.success) {
                    toast.success(`O usuário foi ${user.isActive ? 'desativado' : 'ativado'} com sucesso`, ToasterConfig.success);
                    setTimeout(() => setError(''), 3000);
                    listUsers()
                }
            }
            setLoading(false);
        } catch (error: any) {
            toast.warn(`Falha ao ${user.isActive ? 'desativar' : 'ativar'} usuário`, ToasterConfig.error);
            setLoading(false);
            setError(error.message);
        }
    };

    const handleCopyPassword = (password: string) => {
        navigator.clipboard.writeText(password);
        toast.info('Senha copiada para a área de transferência');
    };

    async function resetUserPassword(user: any) {
        const confirm = window.confirm(
            `Redefinir a senha de ${user.firstName} para a senha padrão do sistema?`
        );
        if (!confirm) return;

        try {
            setLoading(true);
            const result = await resetBackofficeUserPassword(user.id);
            toast.success(
                <div>
                    {result.message}
                    {result.password && (
                        <button type="button" onClick={() => handleCopyPassword(result.password!)}>
                            Copiar senha
                        </button>
                    )}
                </div>,
                {autoClose: false}
            );
        } catch (error: any) {
            const message = error?.response?.data?.errors?.[0]
                ?? error?.response?.data?.message
                ?? 'Falha ao redefinir senha do usuário';
            toast.warn(message, ToasterConfig.error);
        } finally {
            setLoading(false);
        }
    }

    async function deleteUser(user: any) {
        try {
            const confirm = window.confirm(`Tem certeza que deseja apagar o usuário ${user.firstName} ${user.lastName}?`);

            if (confirm) {
                if (user) {
                    await DeleteUser(user.id);
                    toast.success('Usuário deletado com sucesso', {
                        position: "top-center",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                    listUsers()
                }
                setLoading(false);
            }
        } catch (error: any) {
            toast.warn(`Falha ao deletar usuário`, {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            setLoading(false);
            setError(error.message);
        }
    }

    return (
        <div>
            <Header as="h3" textAlign="center" color={'green'}>
                Usuários do backoffice
            </Header>
            <Table.Row>
                <Table.HeaderCell>
                    {sessionUser?.userData?.profile == 'Admin' &&
                        <Button color="green"
                                onClick={() => navigate('/backoffice/users/create/')}>

                            <Icon name='plus'/> Novo
                        </Button>}
                </Table.HeaderCell>
                <Table.HeaderCell colSpan="4">
                    <Button onClick={toggleFilters} color={"green"}>
                        <Icon name={showFilters ? 'hide' : 'unhide'}/>
                        {showFilters ? 'Ocultar filtros' : 'Exibir filtros'}
                    </Button>
                </Table.HeaderCell>
            </Table.Row>
            {showFilters && (
                <Segment>
                    <Grid stackable doubling padded>
                        <Grid.Row>
                            <Grid.Column width={8}>
                                <label htmlFor="userName">Nome do usuário</label>
                                <Input
                                    fluid
                                    id="userName"
                                    icon="search"
                                    type="text"
                                    placeholder="Nome do usuário"
                                    value={filter?.Name ?? ''}
                                    onChange={event => setFilter({ ...filter, Name: event.target.value })}
                                />
                            </Grid.Column>
                            <Grid.Column width={6}>
                                <label htmlFor="userEmail">E-mail</label>
                                <Input
                                    fluid
                                    id="userEmail"
                                    icon="search"
                                    type="text"
                                    placeholder="E-mail"
                                    value={filter?.Email ?? ''}
                                    onChange={event => setFilter({ ...filter, Email: event.target.value })}
                                />
                            </Grid.Column>
                            <Grid.Column width={2} verticalAlign="bottom">
                                <Button color={"green"} onClick={listUsers}>Filtrar</Button>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Segment>
            )}


            <Table color={"green"}>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>#</Table.HeaderCell>
                        <Table.HeaderCell>Nome</Table.HeaderCell>
                        <Table.HeaderCell>Email</Table.HeaderCell>
                        <Table.HeaderCell>Criado em</Table.HeaderCell>
                        <Table.HeaderCell>Ativo</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>

                {sessionUser?.userData?.profile == 'Admin' &&
                    <Table.Body>
                        {users?.map((user) => (
                            <Table.Row key={user.id}>
                                <Table.Cell>
                                    <Button.Group>
                                        <TooltipInfo
                                            content="Editar usuário"
                                            trigger={
                                                <Button
                                                    color="blue"
                                                    onClick={() => navigate('/backoffice/users/edit/' + user.id)}
                                                    icon="edit"
                                                />
                                            }
                                        />

                                        <TooltipInfo
                                            content="Excluir usuário"
                                            trigger={
                                                <Button
                                                    color="red"
                                                    onClick={() => deleteUser(user)}
                                                    icon="trash"
                                                />
                                            }
                                        />

                                        <TooltipInfo
                                            content={user.isActive ? "Desativar usuário" : "Ativar usuário"}
                                            trigger={
                                                <Button
                                                    color={user.isActive ? 'red' : 'green'}
                                                    onClick={() => toggleActivationUser(user)}
                                                    icon={user.isActive ? 'power off' : 'power'}
                                                />
                                            }
                                        />

                                        <TooltipInfo
                                            content="Redefinir senha padrão"
                                            trigger={
                                                <Button
                                                    color="orange"
                                                    onClick={() => resetUserPassword(user)}
                                                    icon="key"
                                                />
                                            }
                                        />
                                    </Button.Group>

                                </Table.Cell>
                                <Table.Cell>{`${user.firstName} ${user?.lastName ?? ''}`}</Table.Cell>
                                <Table.Cell>{user.email}</Table.Cell>
                                <Table.Cell>{moment(user.createdAt).format('DD/MM/YY HH:mm')}</Table.Cell>
                                <Table.Cell>
                                    <Label key={user.id}
                                           color={!user.isActive ? 'red' : 'green'}>{user.isActive ? 'Sim' : 'Não'}</Label>
                                </Table.Cell>
                            </Table.Row>
                        ))}
                    </Table.Body>}
            </Table>
            <Pagination totalPages={totalPages ?? 0}
                        defaultActivePage={filter?.Page ?? 1}
                        onPageChange={(e, {activePage}) => {
                            setFilter({...filter, Page: activePage as number})
                        }
                        }>
            </Pagination>
        </div>
    );
};

export default BackofficeUsersList;
